import { ObjectType } from "@multiweb/types/react";

/**
 * Vytvoří objekt s atributy pro HTMLElement pro automatizované testování.
 */
export const createQA = (qa?: string): ObjectType => qa ? { "data-qa": qa } : {};

/**
 * Oddělovač mezi jednotlivými částmi složené hodnoty pro qa atribut.
 */
export const COMPOSED_QA_SEPARATOR = " ";

/**
 * Vytvoří hodnotu pro qa prop složenou z qa položky a qa rodiče.
 * @param qa QA identifikátor položky.
 * @param parentQA QA identifikátor nadřazené položky.
 */
export const composeQA = (qa: string | number, parentQA?: string | number): string => parentQA ? `${qa}${COMPOSED_QA_SEPARATOR}${parentQA}` : `${qa}`;

/**
 * Vytvoří factory pro skládání názvu pro automatizované testování.
 *
 * Inspirované CSS konvencí BEM.
 * @param componentName QA název komponenty
 * @returns Factory, které se předá QA název podkomponenty a ta pak vrátí složený název komponenty a podkomponenty
 */
export const bemQANames = (componentName: string) =>
    /**
     *
     * @param subcomponentName QA název podkomponenty
     * @returns Složený QA název z komponenty a podkomponenty
     */
    (subcomponentName?: string) => subcomponentName ? `${componentName}__${subcomponentName}` : componentName;
